/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import ReactGA from 'react-ga4';
import AnalyticsChannelBase from './AnalyticsChannelBase';
import { AnalyticsError } from './AnalyticsConfig';

export default class AnalyticsChannelGA4 extends AnalyticsChannelBase {
  constructor() {
    // log all events and errors
    super();

    if (process.env.REACT_APP_GA_STREAM_ID) {
      ReactGA.initialize(process.env.REACT_APP_GA_STREAM_ID, {
        gaOptions: {
          name: 'indigo-selector',
        },
      });
    } else {
      console.error('Failed to init AnalyticsChannelGA4');
    }
  }

  protected _log(category: string, action: string, value?: number, label?: string, additional?: string | number) {
    this._sendEvent(category, action, label, value, additional);
  }

  protected _error(type: AnalyticsError, message?: string) {
    const action = type.split('.')[1];
    console.warn(`AnalyticsChannelGA4._error(): ${action} / ${message ?? '-'}`);
    this._sendEvent('error', action, message);
  }

  private _sendEvent(category: string, action: string, label?: string, value?: number, additional?: string | number) {
    //console.log(`AnalyticsChannelGA4._sendEvent(): ${category} / ${action} / ${label ?? '-'} / ${additional ?? '-'} / ${value ?? '-'}`);
    ReactGA.ga((tracker: any) => {
      ReactGA.set({ additional: `${additional}` });
      ReactGA.event({
        category: category,
        action: action,
        label: label,
        value: value,
        nonInteraction: category === 'implicit',
      });
    });
  }
}
